// Footer.js
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./Footer.module.css";
import HomePageIcons from "./HomePageIcons";

const Footer = () => {
  const location = useLocation();
  const [isDashboard, setIsDashboard] = useState(false);
  
  // Check if we're on the dashboard to apply different styles
  useEffect(() => {
    setIsDashboard(location.pathname.includes('/dashboard'));
  }, [location]);

  return (
    <footer className={`${styles.footer} ${isDashboard ? styles.dashboardFooter : ''}`}>
      <div className={styles.footerText}>
        © {new Date().getFullYear()} Linkist.se. All rights reserved.
        <HomePageIcons />
      </div>
    </footer>
  );
};

export default Footer;